import moment from "moment-timezone";
import { activeZone, zoneAbbreviation } from "../Calendar/slotTime";

// Formats a scheduled interview's date and time together, in the viewer's own time
// zone and labelled with it ("... at 3:00 PM PKT"). The stored value is an
// absolute instant (UTC), so each viewer sees the same moment in their own clock.
export const formatInterviewDateTime = (isoDate: string | Date): string => {
  const when = moment.tz(isoDate, activeZone());
  if (!when.isValid()) return "";
  return `${when.format("MMMM D, YYYY")} at ${when.format("h:mm A")} ${zoneAbbreviation()}`;
};
